import {
  BaseQueryFn,
  EndpointBuilder,
  QueryDefinition,
} from '@reduxjs/toolkit/query';

import type {
  ISignatureEnvelope,
  ISignatureEnvelopeSignageUrl,
} from 'interfaces/SignatureEnvelope.interface';
import type {
  IGetSignatureEnvelopeItemArgs,
  IGetSignatureEnvelopeSignageUrlArgs,
} from './signatureEnvelopes.api.types';

export const getSignatureEnvelopeItem = (
  build: EndpointBuilder<BaseQueryFn, string, string>
): QueryDefinition<
  IGetSignatureEnvelopeItemArgs,
  BaseQueryFn,
  string,
  ISignatureEnvelope
> =>
  build.query<ISignatureEnvelope, IGetSignatureEnvelopeItemArgs>({
    providesTags: ['SignatureEnvelope'],
    query: (queryArg: IGetSignatureEnvelopeItemArgs) => ({
      url: `api/signature_envelopes/${queryArg.id}`,
    }),
  });

export const getSignatureEnvelopeSignageUrl = (
  build: EndpointBuilder<BaseQueryFn, string, string>
): QueryDefinition<
  IGetSignatureEnvelopeSignageUrlArgs,
  BaseQueryFn,
  string,
  ISignatureEnvelopeSignageUrl
> =>
  build.query<
    ISignatureEnvelopeSignageUrl,
    IGetSignatureEnvelopeSignageUrlArgs
  >({
    providesTags: ['SignatureEnvelope'],
    query: (queryArg: IGetSignatureEnvelopeSignageUrlArgs) => ({
      url: `api/signature_envelopes/${queryArg.id}/signage_url`,
    }),
  });
